import { Injectable, inject } from '@angular/core'

import type { SearchTermsResult } from '../../types/types'
import { DateParserService } from '../date-service/date-parser.service'

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly dateParserService = inject(DateParserService)

  parseSearchTerms(searchTerm: string): SearchTermsResult {
    const terms = searchTerm.trim().split(/\s+/)

    if (terms.length === 0) {
      return {
        firstName: '',
        lastName: '',
        searchTerms: '',
      }
    }

    const { dateRange, remainingTerms } =
      this.dateParserService.extractDateRangeFromSearchTerms(terms)
    const firstName = remainingTerms[0] ?? ''
    const lastName =
      remainingTerms.length > 1 ? remainingTerms.slice(1).join(' ') : firstName

    return {
      firstName,
      lastName,
      dateRange: dateRange
        ? { start: dateRange.start, end: dateRange.end }
        : undefined,
      searchTerms: remainingTerms.join(' ').trim(),
    }
  }
}
